// extracted by mini-css-extract-plugin
export var card = "_k0-5";
export var cardSelected = "_k0-4";
export var image = "_k0-3";
export var modal = "_k0-0";
export var modalContent = "_k0-1";
export var table = "_k0-2";